import ComumDataService from "@/services/ComumDataService";

// Busca de CEP independente da lista de sugestões de cidades.
export default {
  data() {
    return {
      cidadesSearchCache: {},
      cepRequestId: 0,
    };
  },
  beforeDestroy() {
    this.cepRequestId += 1;
  },
  methods: {
    getEnderecoCep() {
      return this.recurso;
    },
    formatCidade(item) {
      return (
        (item?.nome || "") +
        (item?.estado?.sigla ? "/" + item.estado.sigla : "") +
        (item?.estado?.pais?.nome ? " - " + item.estado.pais.nome : "")
      );
    },
    async buscaCep(event) {
      const requestId = ++this.cepRequestId;
      const recurso = this.recurso;
      const enderecoAtual = this.getEnderecoCep();
      if (!enderecoAtual) {
        return;
      }
      const cep = String(
        event?.target?.value ?? enderecoAtual.cep ?? ""
      ).replace(/\D/g, "");
      if (cep.length !== 8) {
        return;
      }

      const cidadeAnterior = enderecoAtual.cidade;
      const logradouroAnterior = enderecoAtual.logradouro;
      const bairroAnterior = enderecoAtual.bairro;
      const consultaAtual = () =>
        requestId === this.cepRequestId &&
        !this._isDestroyed &&
        !this._isBeingDestroyed &&
        this.recurso === recurso &&
        this.getEnderecoCep() === enderecoAtual &&
        String(enderecoAtual.cep || "").replace(/\D/g, "") === cep;

      try {
        const { data: endereco } = await ComumDataService.buscaCep(cep);
        if (
          !consultaAtual() ||
          endereco?.erro ||
          !endereco?.localidade ||
          !endereco?.uf
        ) {
          return;
        }
        const { data: cidade } = await ComumDataService.findCidade({
          cidade: endereco.localidade,
          uf: endereco.uf,
        });
        if (!consultaAtual() || enderecoAtual.cidade !== cidadeAnterior) {
          return;
        }

        this.$set(enderecoAtual, "cidade", cidade || null);
        if (enderecoAtual.logradouro === logradouroAnterior) {
          this.$set(enderecoAtual, "logradouro", endereco.logradouro || "");
        }
        if (enderecoAtual.bairro === bairroAnterior) {
          this.$set(enderecoAtual, "bairro", endereco.bairro || "");
        }
      } catch (error) {
        console.error("Erro ao consultar CEP", error);
      }
    },
  },
};
